/*
=========================================================
Muse - Vue Ant Design Dashboard - v1.0.0
=========================================================

Product Page: https://www.creative-tim.com/product/vue-ant-design-dashboard
Copyright 2021 Creative Tim (https://www.creative-tim.com)
Coded by Creative Tim

=========================================================
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 
*/

import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
// import './plugins/click-away'

import './scss/app.scss';

// axios
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from "./config.js"
// auth
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'
// moment
import moment from 'moment'
// vuex
import store from './store/index';
// report
import * as XLSX from 'xlsx';
// image select
import VueSelectImage from 'vue-select-image'
// apex chart
import VueApexCharts from 'vue-apexcharts'
// chart gauge
import VueGauge from "vue-gauge";
// print pdf
import VueHtmlToPaper from 'vue-html-to-paper';

Vue.use(Antd);

// Vue.config.productionTip = false

// Configure axios
axios.defaults.baseURL = config.apiUrl
Vue.use(VueAxios, axios)
Vue.use(VueSelectImage)
// import { extendMoment } from 'moment-range';

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(VueGauge)

// pdf
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css'
  ],
  // timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  // windowTitle: window.document.title, // override the window title
}
Vue.use(VueHtmlToPaper,options);

// Vue.prototype.moment = extendMoment(moment)
Vue.prototype.moment = moment
// excle xls
Vue.prototype.XLSX = XLSX

// GA TAG Router
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-179956144-1',
  // id: 'G-CT3JP41ECS',
  router,
})

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

// token intercepter
function tokenInterceptor () {
  axios.interceptors.request.use(config => {
    // console.log('config', config)
    config.headers.Authorization = Vue.prototype.$keycloak.token !== null ? `Bearer ${Vue.prototype.$keycloak.token}` : `Token b5d48ab87dcfbb180ebb1876c0afa2501978e6c6`
    // config.headers.responseType = `stream`
    return config
  }, error => {
    return Promise.reject(error)
  })
}


Vue.use(VueKeycloakJs, {
  init: {
    // Use 'login-required' to always require authentication
    // If using 'login-required', there is no need for the router guards in router.js
    onLoad: 'check-sso'
  },
  config: {
    // url: 'https://idp-bridge.muic.io/auth',
    url: 'https://sso.muic.io/auth',
    clientId: 'my-staff',
    realm: 'IC'
  },
  onReady: (keycloak) => {
    tokenInterceptor()
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')